import {BaseService} from "./base.service";

class ExtraUserQuoterService extends BaseService {

    constructor() {
        super('api/extra-user-quotes')
    }

    printQuote(id) {
        return this.http.get(`api/print-quoter-workers/${id}`).then(response => response.data).catch(err => err.message);
    }

}

export const extraUserQuoterService = new ExtraUserQuoterService();
